import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getAllCategorys, getFillterCategorys } from '../../redux/actions/category';
import { useStateContext } from '../../context/ContextProvider';
import { FeaturedMealsCard, Loader, MealCategoryCard } from '../utils';
import { motion } from 'framer-motion';
import { getAllFeaturedMeals } from '../../redux/actions/featuredMeals';
import { FaFireAlt } from 'react-icons/fa';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';

function FeaturedMealSections() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentLang, currentDir } = useStateContext();
  const IsArabic = currentLang === "ar";
  const { isLoading, Allmeals } = useSelector((state) => state.FeaturedMeals);

  useEffect(() => {
    // عرض جميع الفئات بدون pagination
    dispatch(getAllFeaturedMeals());
  }, [dispatch]);


  return (

    <section className="relative py-24 md:py-32 overflow-hidden bg-back-primery dark:bg-back-darkprimery">
    
      {/* Background Effects */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-color-1/10 rounded-full blur-3xl"></div>
    
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-color-3/10 rounded-full blur-3xl"></div>
    
      <div className="container relative z-10">
    
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
    
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-color-1/10 border border-color-1/20 mb-6">
    
            <FaFireAlt className="text-color-1" />
    
            <span className="font-kufi text-color-1">
              {t("exclusive offers")}
            </span>
    
          </div>
    
          <h2 className="h1 text-tcolor-4 dark:text-tcolor-1 mb-6">
    
            {t("Offers")}
    
          </h2>
    
          <p className="body-2 text-n-6 dark:text-tcolor-2 max-w-3xl mx-auto leading-loose">
    
            {t("Discover our special offers - great value, amazing taste, unforgettable experience.")}
    
          </p>
    
        </motion.div>
    
        {/* Cards */}
        {
          isLoading ? (
    
            <Loader />
    
          ) : (
    
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
    
              {Allmeals?.map((meal) => (
                <FeaturedMealsCard
                  key={meal._id}
                  meals={meal}
                />
              ))}
    
            </div>
    
          )
        }
    
        {/* Button */}
        <div className="flex justify-center mt-16">
    
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.location.href = '/AllFeaturedMeals'}
            className="group relative overflow-hidden px-10 py-5 rounded-full bg-color-1 text-white font-kufi shadow-2xl"
          >
    
            <span className="relative z-10 flex items-center gap-3">
    
              {t("view all Featured Meals")}
    
              <FiArrowLeft className="group-hover:translate-x-1 duration-300" />
    
            </span>
    
            <div className="absolute inset-0 bg-gradient-to-r from-color-1 to-color-3 opacity-0 group-hover:opacity-100 duration-500"></div>
    
          </motion.button>
    
        </div>
    
      </div>
    
    </section>
  
    
  );
}

export default FeaturedMealSections;